import styles from './ErrorPage.module.scss'; // Import du SCSS modulaire

const ErrorPage = () => {
    return (
        <div className={styles.errorContainer}>
            <div className={styles.errorContent}>
                <h1 className={styles.errorTitle}>Application Inaccessible</h1>
                <p className={styles.errorMessage}>
                    Désolé, l&apos;application est actuellement inaccessible. Veuillez réessayer plus tard.
                </p>
                <div className={styles.errorAnimation}></div>
            </div>
        </div>
    );
};

export default ErrorPage;